function walkGame(wrap_div,conf){
    conf=$.extend(true,{
        security_count:8,
        "img_all":{
            cell_hide:_IMG_SERV+"/gfx/place/walkgame/cell/hide.png",
            cell_walk:_IMG_SERV+"/gfx/place/walkgame/cell/blue.png",
            cell_dron:_IMG_SERV+"/gfx/place/walkgame/cell/dron_min.png",
            cell_black:_IMG_SERV+"/gfx/place/walkgame/cell/black.png",
            cell_back:_IMG_SERV+"/gfx/place/walkgame/back_hidder.jpg",
            event_slow:_IMG_SERV+"/gfx/place/walkgame/cell/pack1.png",
            event_stop:_IMG_SERV+"/gfx/place/walkgame/cell/pack2.png",
            event_ui_slow:_IMG_SERV+"/gfx/place/walkgame/ui/down/bonusBig1.png",
            event_ui_stop:_IMG_SERV+"/gfx/place/walkgame/ui/down/bonusBig2.png",
            ui_fill:_IMG_SERV+"/gfx/place/walkgame/ui/bar.png",
            ui_border:_IMG_SERV+"/gfx/place/walkgame/map/border.png",
//            ui_ruler:_IMG_SERV+"/gfx/place/walkgame/map/ruler.png",
            ui_main:_IMG_SERV+"/gfx/place/walkgame/map/back.png"

        },
        "spine_all":{
            dron:_IMG_SERV+"/gfx/place/walkgame/cell/dron/skeleton.json",
            security:_IMG_SERV+"/gfx/place/walkgame/cell/police/skeleton.json"
        },
        dronAnims:["animation"],
        cell_size:24,
        walker_speed:100,
        full_size:[960,600],
        event_arr:[],
        onSucc:function(cur,full){

        },
        onFail:function(res){},
        onLoad:function(){}
    },conf);
    this.conf=conf;
    var thc=this;
    var loaderMain = new PIXI.loaders.Loader();
    var i;
    for(i in conf.img_all){
        if(conf.img_all[i]){
            loaderMain.add("img_"+i,conf.img_all[i]);
        }
    }

    for(i in conf.spine_all){
        loaderMain.add(i,conf.spine_all[i]);
    }
    this.joystick=new addJoystick({degArr:[0,90,180,270],region_extend:100,pos:[1162,346]});
    var joystickUrl=this.joystick.addToPreloader();
    for(i in joystickUrl){
        loaderMain.add(i,joystickUrl[i]);
    }

    this.arrow=new addJoystick({
        degArr:[0,90,180,270],
        region_extend:3,
        pos:[1162,346],
        url_pref:"addArrow",
        hide_pointer:1,
        urls:{
            back:_IMG_SERV+"/gfx/place/walkgame/ui/pad.png",
        }
    });
    var arrowUrl=this.arrow.addToPreloader();
    for(i in arrowUrl){
        loaderMain.add(i,arrowUrl[i]);
    }



    wrap_div.append(
        "<canvas style='position:absolute;left:0px;top:0px;'></canvas>"+
        "<div class='touchDivJS fourDirection'></div>"
    );
    this.app = new PIXI.Application({
        width: 1280, height: 780,antialias: true,transparent:true,
        view:wrap_div.find("canvas")[0]
    });
    this.wrap_div=wrap_div;
    this.resources={};
    this.state="";
    this.ctrMode="joystick";//arrow
    loaderMain.load(function(loader, resources){
        thc.resources=resources;
        thc.init();
        conf.onLoad();
    });

    _moduleEvents.one("moduleClear",function(){
        $(document).off("keydown.walker");
        if(typeof app!="undefined" && app!=null){
            app.destroy();
        }
        if(typeof loaderMain.reset!="undefined"){
            loaderMain.reset();
        }
    });
}
walkGame.prototype= {
    init:function(){
        var thc=this;
        this.map=new walkGameMap({cell_size:this.conf.cell_size});
        var mainContainer=new PIXI.Container();
        mainContainer.x=66;
        mainContainer.y=64;

        var borderContainer=new PIXI.Container();


        var frontContainer=new PIXI.Container();

        this.app.stage.addChild(mainContainer);
        this.app.stage.addChild(frontContainer);

        mainContainer.addChild(new myPixiElement.img({img:"img_ui_main",
            anchor:[0,0],pos:[-11,-10]}));
        mainContainer.addChild(borderContainer);

        this.addBorderImg(borderContainer);

        mainContainer.addChild(this.map);

        this.map.init();
        if(this.isMobile()){
            this.joystick.init();
            this.arrow.init();
        }
        this.joystick.alpha=0;
        this.arrow.alpha=0;

        this.events=new walkGameEvents({event_arr:this.conf.event_arr},this.map);
        mainContainer.addChild(this.events);






        mainContainer.addChild(new myPixiElement.img({img:"img_ui_border",
            anchor:[0,0],pos:[-47,-63]}));
//        mainContainer.addChild(new myPixiElement.img({img:"img_ui_ruler",
//            anchor:[0,0],pos:[-14,-13]}));




        this.securityArr={};
        var i;
        for(i=0;i<this.conf.security_count;i++){
            this.securityArr[i]=new walkGameSecurity({
                id:i,security_max:this.conf.security_count,
                cell_size:this.conf.cell_size,
                speed:this.conf.security_speed
            },this.map,this.resources);
            this.securityArr[i].init();
            mainContainer.addChild(this.securityArr[i]);
        }

        this.walker=new walkGameWalker({
            cell_size:this.conf.cell_size,
            anims_arr:this.conf.dronAnims,
            speed:this.conf.walker_speed,
            onFail:function(res){
                thc.conf.onFail(res);
            }
        },this.map,this.resources);

        mainContainer.addChild(this.walker);

        this.eventTimer=new walkGameEventTimer({event_arr:this.conf.event_arr},this.walker);
        mainContainer.addChild(this.eventTimer);

        if(this.isMobile()){
            frontContainer.addChild(this.joystick);
            frontContainer.addChild(this.arrow);
        }


        this.initDesktop();



        this.conf.onSucc(this.map.size_full,this.map.size_full);


        _moduleEvents.one("moduleClear",function(){
            if(typeof thc.app!="undefined" && thc.app!=null){
                thc.app.destroy();
            }
        });
    },
    addBorderImg:function(cont){
        cont.alpha=0.9;
        cont.x=-this.conf.cell_size/2;
        cont.y=-this.conf.cell_size/2;
        cont.addChild(new myPixiElement.imgCrop({img:"img_cell_back",
            anchor:[0,0],
            pos:[0,0],
            size:[this.conf.full_size[0],this.conf.cell_size],//new image size
            cropPos:[0,0],//position off cropping

        }));
        cont.addChild(new myPixiElement.imgCrop({img:"img_cell_back",
            anchor:[0,0],
            pos:[0,this.conf.full_size[1]-this.conf.cell_size],
            size:[this.conf.full_size[0],this.conf.cell_size],//new image size
            cropPos:[0,this.conf.full_size[1]-this.conf.cell_size],//position off cropping

        }));
        cont.addChild(new myPixiElement.imgCrop({img:"img_cell_back",
            anchor:[0,0],
            pos:[0,this.conf.cell_size],
            size:[this.conf.cell_size,this.conf.full_size[1]-this.conf.cell_size*2],//new image size
            cropPos:[0,this.conf.cell_size],//position off cropping

        }));
        cont.addChild(new myPixiElement.imgCrop({img:"img_cell_back",
            anchor:[0,0],
            pos:[this.conf.full_size[0]-this.conf.cell_size,this.conf.cell_size],
            size:[this.conf.cell_size,this.conf.full_size[1]-this.conf.cell_size*2],//new image size
            cropPos:[this.conf.full_size[0]-this.conf.cell_size,this.conf.cell_size],//position off cropping

        }));


        var borderLine=new PIXI.Graphics();
        borderLine.alpha=0.3;
        borderLine.lineStyle(1, 0x000000);
        borderLine.moveTo(this.conf.cell_size,this.conf.cell_size);
        borderLine.lineTo(this.conf.full_size[0]-this.conf.cell_size,this.conf.cell_size);
        borderLine.lineTo(this.conf.full_size[0]-this.conf.cell_size,this.conf.full_size[1]-this.conf.cell_size);
        borderLine.lineTo(this.conf.cell_size,this.conf.full_size[1]-this.conf.cell_size);
        borderLine.lineTo(this.conf.cell_size,this.conf.cell_size);
        borderLine.endFill();
        cont.addChild(borderLine);
    },
    start:function(){
        var thc=this;
        if(this.isMobile){
            this.initJoystick();
//            this.initJoystick2();
            this.initArrowScreen();
        }

        this.state="game";

        this.app.ticker.add(
            function(delta){thc.gameLoop(delta);}
        );
        _moduleEvents.trigger("walksound","start_game");
    },
    isMobile:function(){
        if(_isMobile){
            return 1;
        }
        return 0;
    },
    initDesktop:function(){
        var key_line={
            "40":{val:[0,1]},
            "39":{val:[1,0]},
            "38":{val:[0,-1]},
            "37":{val:[-1,0]}
        };
        var thc=this;
        $(document).off("keydown.walker").on("keydown.walker",function(e){
            if(thc.state=="game" && typeof key_line[e.which]!="undefined"){
                var obj=key_line[e.which];
                thc.walker.changeDirection(copyArray(obj.val));
                e.preventDefault();
            }
        });
    },
    changeMobileCtr:function(){
        if(!this.isMobile()){
            return false;
        }
        this.walker.stopWalk();
        if(this.ctrMode=="arrow"){
            this.ctrMode="joystick";
            this.joystick.alpha=1;
            this.arrow.alpha=0;
        }
        else{
            this.ctrMode="arrow";
            this.joystick.alpha=0;
            this.arrow.alpha=1;
        }
        return this.ctrMode;
    },
    initArrowScreen:function(){
        var thc=this;
        var key_line={
            "180":{val:[0,1]},
            "90":{val:[1,0]},
            "0":{val:[0,-1]},
            "270":{val:[-1,0]}
        };
        var touchObj=new addTouch(this.wrap_div.find(".touchDivJS")[0],{
            onStart:function(arr){
                if(thc.state=="game" && thc.ctrMode=="arrow"){

                    arr=arr[0];
                    var deg=thc.arrow.setPointer(arr);
                    if(deg>=0){
                        var obj=key_line[deg];
                        thc.walker.changeDirection(copyArray(obj.val));
                    }
                    thc.walker.continueWalk();
                }
            },
            onEnd:function(){
                if(thc.ctrMode=="arrow"){
                    thc.walker.stopWalk();
                }

            },
        });
    },
    initJoystick:function(){
        this.joystick.alpha=1;
        var key_line={
            "180":{val:[0,1]},
            "90":{val:[1,0]},
            "0":{val:[0,-1]},
            "270":{val:[-1,0]}
        };

        var thc=this;

        var joystick_threshold=[
            [950,1280],
            [0,550]
        ];
        var joystick_size=[60,60];

        var joystick_border=[
            [joystick_threshold[0][0]+joystick_size[0],joystick_threshold[0][1]-joystick_size[0]],
            [joystick_threshold[1][0]+joystick_size[1],joystick_threshold[1][1]-joystick_size[1]]
        ];

        var touchObj=new addTouch(this.wrap_div.find(".touchDivJS")[0],{
            onStart:function(arr){
                if(thc.ctrMode=="joystick"){
                    arr=arr[0];


                    if(arr[0]>=joystick_border[0][0] && arr[0]<=joystick_border[0][1] &&
                    arr[1]>=joystick_border[1][0] && arr[1]<=joystick_border[1][1]  ){
                        thc.joystick.x=arr[0];
                        thc.joystick.y=arr[1];
                    }
                    thc.walker.continueWalk();
                }


//

            },
            onEnd:function(){
                if(thc.ctrMode=="joystick"){
                    thc.walker.stopWalk();
                }

            },
            onMove:function(arr){
                if(thc.state=="game" && thc.ctrMode=="joystick"){
                    arr=arr[0];
                    var deg=thc.joystick.setPointer(arr);
                    if(deg>=0){
                        var obj=key_line[deg];
                        thc.walker.changeDirection(copyArray(obj.val));
                    }
                }
            },

        });
    },
    initJoystick2:function(){
        this.joystick.alpha=1;
        var key_line={
            "180":{val:[0,1]},
            "90":{val:[1,0]},
            "0":{val:[0,-1]},
            "270":{val:[-1,0]}
        };

        var thc=this;

        var joystick_threshold=[
            [950,1280],
            [0,550]
        ];
        var joystick_size=[60,60];

        var joystick_border=[
            [joystick_threshold[0][0]+joystick_size[0],joystick_threshold[0][1]-joystick_size[0]],
            [joystick_threshold[1][0]+joystick_size[1],joystick_threshold[1][1]-joystick_size[1]]
        ];

        var last_pos=[];
        var precR=50;
        var touchObj=new addTouch(this.wrap_div.find(".touchDivJS")[0],{
            onStart:function(arr){
                if(thc.ctrMode=="joystick"){
                    arr=arr[0];
                    thc.walker.continueWalk();
                    last_pos=[arr[0],arr[1]];
                }


//

            },
            onEnd:function(){
                if(thc.ctrMode=="joystick"){
                    thc.walker.stopWalk();
                }

            },
            onMove:function(arr){
                if(thc.state=="game" && thc.ctrMode=="joystick"){
                    arr=arr[0];
                    if(arr[0]!=last_pos[0] || arr[1]!=last_pos[1]){

                        if(lengthVectorPow(makeVector(arr,last_pos))>=precR){
                            var deg=thc.joystick.setPointer(arr,last_pos);
                            if(deg>=0){
                                var obj=key_line[deg];
                                thc.walker.changeDirection(copyArray(obj.val));
                            }
                            last_pos=[arr[0],arr[1]];
                        }



                    }

                }
            },

        });
    },
    gameLoop:function(delta){
        var i,k;
        var walker_end=0;
        this.walker.myUpdate(delta);
        if(this.walker.tryClearPath()){
            walker_end=1;
        }

        var checkPath=this.walker.checkPathWithSecurity();
        this.events.myUpdate(delta);
        var events,event_type;


        if(checkPath.length){
            for(i in this.securityArr){
                this.securityArr[i].checkWithPath(checkPath);
            }

        }
        events=this.events.checkWithPath(this.walker.takeEventPos());
        var howlong_mili=2500;
        for(k in events){
            event_type=events[k];
            if(event_type=="stop"){
                for(i in this.securityArr){
                    this.securityArr[i].setSpeed(0,howlong_mili);
                }
            }
            else if(event_type=="slow"){
                for(i in this.securityArr){
                    this.securityArr[i].setSpeed(0.3,howlong_mili);
                }
            }
            this.eventTimer.start(event_type,howlong_mili);

        }
        this.eventTimer.myUpdate(delta);

        var error_id=0;

        for(i in this.securityArr){
            this.securityArr[i].myUpdate(delta);
            error_id=this.securityArr[i].isOnPath();
            if(error_id>0 && walker_end==0){
                this.walker.endPath("fail",error_id);
            }
        }

        if(walker_end){
            var secArr=[];
            for(i in this.securityArr){
                secArr.push(this.securityArr[i].takeObj());
            }
            var result=this.map.findRegions(secArr);
            this.conf.onSucc(result.size_cur,result.size_full);
            //return {sec2del:sec2del,size_cur:this.size_cur,size_full:this.size_full};
            var sec2del=result.sec2del;
            for(i in sec2del){
                this.securityArr[sec2del[i]].myRemove();
                delete this.securityArr[sec2del[i]];
            }
            _moduleEvents.trigger("walksound","clear_area");
        }
    },
    setGameState:function(state){
        this.state=state;
    }
};
